"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var styled=_interopDefault(require("styled-components"));function _templateObject(){var e=_taggedTemplateLiteral([""]);return _templateObject=function(){return e},e}function _taggedTemplateLiteral(e,t){return t=t||e.slice(0),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}function UNSAFE_SetEnvRef(){return"function"==typeof styled.div(_templateObject()).extend?"innerRef":"ref"}exports.default=UNSAFE_SetEnvRef;



//////////////////
// WEBPACK FOOTER
// ./~/@uie/set-env-ref/dist/index.cjs.min.js
// module id = 75
// module chunks = 0